module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-10.00ff516a.png";